import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { CalendarClock, X } from "lucide-react";

export default function TodayReminderPopup() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/me/today-reminders").then(({ data }) => {
      if (data.length > 0) { setItems(data); setOpen(true); }
    }).catch(() => {});
  }, [user?.id]); // eslint-disable-line

  const dismiss = async (jobId) => {
    try { await api.post(`/me/today-reminders/${jobId}/dismiss`); } catch {}
    setItems(prev => {
      const next = prev.filter(i => i.job_id !== jobId);
      if (next.length === 0) setOpen(false);
      return next;
    });
  };

  if (!open || items.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" onClick={() => setOpen(false)}>
      <div className="bg-card rounded-2xl p-6 max-w-sm w-full" onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-1">
          <CalendarClock className="w-5 h-5 text-brand" />
          <h3 className="font-display text-xl">
            {items.some(i => i.kind === "event") ? "You have an event today" : "You have work today"}
          </h3>
        </div>
        <p className="text-xs text-muted-foreground mb-4">
          {items.length > 1 ? `${items.length} items scheduled for today.` : "Here's what's on for today."}
        </p>
        <div className="space-y-2">
          {items.map(it => (
            <div key={it.job_id} className="flex items-center justify-between gap-2 p-3 rounded-lg border border-border">
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{it.title}</p>
                <p className="text-[11px] text-muted-foreground">{it.kind === "event" ? "Your event" : "Your job"}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <Link to={it.kind === "event" ? `/events/${it.job_id}` : `/job/${it.job_id}`} onClick={() => setOpen(false)} className="btn-tint !py-1 !px-2 text-xs">View</Link>
                <button onClick={() => dismiss(it.job_id)} className="text-muted-foreground hover:text-red-500" title="Don't show again today">
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
        <button onClick={() => setOpen(false)} className="btn-outline w-full mt-4 text-sm">Close</button>
      </div>
    </div>
  );
}